import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { selectApplovinPixelId } from 'root-redux/selects/common'

import { useCookieConsentAnswer } from './useCookieConsentAnswer'
import { useGetPageInfo } from './useGetPageInfo'

export const useApplovinPixelInitialization = (): void => {
  const applovinPixelId = useSelector(selectApplovinPixelId)
  const { canUseAdvertising } = useCookieConsentAnswer()

  const { currentPageId } = useGetPageInfo()
  const { pathname } = useLocation()

  useEffect(() => {
    if (!currentPageId || !applovinPixelId || !canUseAdvertising) {
      return
    }

    const axonScript = document.createElement('script')

    axonScript.type = 'text/javascript'
    axonScript.text = `
    var AXON_EVENT_KEY="${applovinPixelId}";
    !function(e,r){var
    t=["https://s.axon.ai/pixel.js","https://c.albss.com/p/l/loader.iife.js"];if(!e
    .axon){var
    a=e.axon=function(){a.performOperation?a.performOperation.apply(a,arguments):a.
    operationQueue.push(arguments)};a.operationQueue=[],a.ts=Date.now(),a.eventKey=
    AXON_EVENT_KEY;for(var
    n=r.getElementsByTagName("script")[0],o=0;o<t.length;o++){var
    i=r.createElement("script");i.async=!0,i.src=t[o],n.parentNode.insertBefore(i,n
    )}}}(window,document);
    axon("init");
    `
    document.body.appendChild(axonScript)
  }, [applovinPixelId, currentPageId, canUseAdvertising])

  useEffect(() => {
    if (!canUseAdvertising) {
      return
    }

    window.axon && window.axon('track', 'page_view')
  }, [canUseAdvertising, pathname])
}
